export default {"src":"/_next/static/media/0xc7198437980c041c805a1edcba50c1ce5db95118.fc08aec8.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};